import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ExamLevelsDataTable {
  constructor() {
    $(document).ready(function() {
      showExamLevelsTable();
    });

    $(document).on("turbo:render", function() {
      showExamLevelsTable();
    });

    function showExamLevelsTable() {
      $('#exam-levels-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#exam-levels-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "exam_type"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
